import * as puntgenie from './TextInput.styles.puntgenie';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  puntgenie,
};
